import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  button {
    margin-left: 0;
    margin-right: 0;
  }

  span {
    text-transform: capitalize;
  }
`;

export const BetButton = styled.button<{
  active?: boolean;
  uppercase?: boolean;
}>`
  font-size: 1.3rem;
  font-weight: bold;
  display: flex;
  cursor: pointer;
  border: none;
  justify-content: flex-start;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  padding: 0.8rem;
  margin: 0 0.3rem;
  @media (min-width: 370px) {
    margin: 0 0.6rem;
  }
  > span {
    line-height: 1.1;
  }
  > span:first-of-type {
    word-wrap: break-word;
    text-align: left;
    margin-right: 0.6rem;
    text-transform: ${(props) =>
      props.uppercase ? "uppercase" : "capitalize"};
  }
  > span:last-of-type {
    margin-left: auto;
  }
  background: ${(props) =>
    props.active ? props.theme.flashpicksBlue : props.theme.defaultButtonBg};
  color: ${(props) => (props.active ? props.theme.white : props.theme.black)};
`;
